import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import OrderTinglysteDokumenterIcon from '../../../../images/gammel grunnbok.png'
import BestillTinglystDokumentIcon from '../../../../images/submenu_open copy 5.png'
import WarningIcon from '../../../../images/advarsel2.png'

class OrderTinglysteDokumenter extends Component {
    state = {
        selectedDocument: null,

        hjemmelsopplysninger: [],
        isLoadingHjemmelsopplysninger: false,
        pengeheftelser: [],
        isLoadingPengeheftelser: false,
        servitutter: [],
        isLoadingServitutter: false,
        grunndata: [],
        isLoadingGrunndata: false,

        isLoading: false,
        orderError: null,
        orderReference: null
    }

    UNSAFE_componentWillMount = () => {
        this.getHjemmelsopplysninger()
        this.getPengeheftelser()
        this.getServitutter()
        this.getGrunndata()
    }

    onSelectDocument = (document) =>  {
        document.isValidating = true;
        this.setState({state: this.state})        
        this.kanPantebokbestilles(document.embetenummer, document.dokumentaar, document.dokumentnummer).then(response => {
            document.isValidating = false
            if (response.data.kanPantebokbestilles) {
                this.setState({selectedDocument: { embetenummer: document.embetenummer, dokumentaar: document.dokumentaar, dokumentnummer: document.dokumentnummer, erBestilt: document.erBestilt }})
                return
            }

            document.kanPantebokbestilles = false
            this.setState({state: this.state})
        })
    }

    sendOrder = () => {
        if (this.state.isLoading) return;
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/bestilltinglystdokument/`, {
            params: {
                token: this.props.token,
                embetenummer: this.state.selectedDocument.embetenummer,
                navn: this.fulltnavn.value,
                dokumentaar: this.state.selectedDocument.dokumentaar,
                dokumentnummer: this.state.selectedDocument.dokumentnummer,
                adresse: this.gatenavnognummer.value,
                postnummer: this.postnummer.value,
                fakturareferanse: this.fakturareferanse.value
            }
        })
        .then(({data}) => {
            this.setState({
                isLoading: false,
                orderError: data.feil,
                orderReference: data.referansenummer ? data.referansenummer : null
            })
        })
    }

    kanPantebokbestilles = async (embetenummer, dokumentaar, dokumentnummer) => {
        var response = await axios.get(`${this.props.settings.baseUrl}api/grunnbok/validerpantebokbestilling/`, {
            params: {
                token: this.props.token,
                embetenummer: embetenummer,
                dokumentaar: dokumentaar || -1,
                dokumentnummer: dokumentnummer || -1
            }
        })

        return response
    }

    getHjemmelsopplysninger = () => {
        this.setState({isLoadingHjemmelsopplysninger: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/hjemmelsopplysning/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                hjemmelsopplysninger: [...this.state.hjemmelsopplysninger, ...data.hjemmelsopplysninger],
                isLoadingHjemmelsopplysninger: false
            })
        })
    }

    getPengeheftelser = () => {
        this.setState({isLoadingPengeheftelser: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/pengeheftelse/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                pengeheftelser: [...this.state.pengeheftelser, ...data.pengeheftelser],
                isLoadingPengeheftelser: false
            })
        })
    }

    getServitutter = () => {
        this.setState({isLoadingServitutter: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/servitutt/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                servitutter: [...this.state.servitutter, ...data.servitutter],
                isLoadingServitutter: false
            })
        })
    }

    getGrunndata = () => {
        this.setState({isLoadingGrunndata: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/grunndata/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                grunndata: [...this.state.grunndata, ...data.grunndata],
                isLoadingGrunndata: false
            })
        })
    }

    render() {
        const { t } = this.props

        return (
            <li>
                <div className="section-header navigation" onClick={this.props.onNavigateBack}>
                    <span className="icon"><i className={"fa fa-fw fa-arrow-left"}></i></span>
                    <span className="title">{t('tilbake')}</span>
                </div>

                <div className="section-header defaultcursor">
                    <div className="icon-image"><img src={OrderTinglysteDokumenterIcon} /></div>
                    <span className="title">{t('bestilltinglystedokumenter')}</span>
                </div>

                  { this.state.orderReference == null &&  !this.state.selectedDocument &&
                    <React.Fragment>
                        <ul>
                            <li>
                                <div className="section-header defaultcursor">
                                    { !this.state.isLoadingHjemmelsopplysninger &&
                                        <div className="icon-image"><div className="img"></div></div>
                                    }
                                    { this.state.isLoadingHjemmelsopplysninger &&
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    }
                                    <span className="title">{t('hjemmelsopplysninger')}</span>
                                </div>
                            </li>
                            { this.state.hjemmelsopplysninger.map((d, index) => { return (
                                <li key={d.dokumentnummer+d.dokumentnavn} className="section-header subsection defaultcursor">
                                    <span className={`icon sublevel ${index == this.state.hjemmelsopplysninger.length-1 ? 'sublevel-end' : ''}`}></span>
                                    <span className="title">{d.dokumentaar} {d.dokumentnavn}</span>
                                    { d.kanPantebokbestilles == false && <div className="icon-image tooltip warning">
                                        <img className="tool" src={WarningIcon} />
                                        <div className="tooltip-content">{t('kanikkebestilletinglystdokument')}</div>
                                    </div> }
                                    <div className="icon-image right"><div className="collapse"></div></div>
                                    { !d.isValidating && d.kanPantebokbestilles == undefined && <div className="icon-image right tooltip" onClick={e => this.onSelectDocument(d)}>
                                        <img className="tool" src={BestillTinglystDokumentIcon} />
                                        <div className="tooltip-content">{t('bestilltinglystdokument')}</div>
                                    </div>}
                                    { d.isValidating && <div className="icon-image right">
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    </div>}
                                </li>
                            )})}
                            <li>
                                <div className="section-header defaultcursor">
                                    { !this.state.isLoadingPengeheftelser &&
                                        <div className="icon-image"><div className="img"></div></div>
                                    }
                                    { this.state.isLoadingPengeheftelser &&
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    }
                                    <span className="title">{t('pengeheftelser')}</span>
                                </div>
                            </li>
                            { this.state.pengeheftelser.map((d, index) => { return (
                                <li key={d.dokumentnummer+d.dokumentnavn} className="section-header subsection defaultcursor">
                                    <span className={`icon sublevel ${index == this.state.pengeheftelser.length-1 ? 'sublevel-end' : ''}`}></span>
                                    <span className="title">{d.dokumentaar} {d.dokumentnavn}</span>
                                    { d.kanPantebokbestilles == false && <div className="icon-image tooltip warning">
                                        <img className="tool" src={WarningIcon} />
                                        <div className="tooltip-content">{t('kanikkebestilletinglystdokument')}</div>
                                    </div> }
                                    <div className="icon-image right"><div className="collapse"></div></div>
                                    { !d.isValidating && d.kanPantebokbestilles == undefined && <div className="icon-image right tooltip" onClick={e => this.onSelectDocument(d)}>
                                        <img className="tool" src={BestillTinglystDokumentIcon} />
                                        <div className="tooltip-content">{t('bestilltinglystdokument')}</div>
                                    </div>}
                                    { d.isValidating && <div className="icon-image right">
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    </div>}
                                </li>
                            )})}
                            <li>
                                <div className="section-header defaultcursor">
                                    { !this.state.isLoadingServitutter &&
                                        <div className="icon-image"><div className="img"></div></div>
                                    }
                                    { this.state.isLoadingServitutter &&
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    }
                                    <span className="title">{t('servitutter')}</span>
                                </div>
                            </li>
                            { this.state.servitutter.map((d, index) => { return (
                                <li key={d.dokumentnummer+d.dokumentnavn} className="section-header subsection defaultcursor">
                                    <span className={`icon sublevel ${index == this.state.servitutter.length-1 ? 'sublevel-end' : ''}`}></span>
                                    <span className="title">{d.dokumentaar} {d.dokumentnavn}</span>
                                    { d.kanPantebokbestilles == false && <div className="icon-image tooltip warning">
                                        <img className="tool" src={WarningIcon} />
                                        <div className="tooltip-content">{t('kanikkebestilletinglystdokument')}</div>
                                    </div> }
                                    <div className="icon-image right"><div className="collapse"></div></div>
                                    { !d.isValidating && d.kanPantebokbestilles == undefined && <div className="icon-image right tooltip" onClick={e => this.onSelectDocument(d)}>
                                        <img className="tool" src={BestillTinglystDokumentIcon} />
                                        <div className="tooltip-content">{t('bestilltinglystdokument')}</div>
                                    </div>}
                                    { d.isValidating && <div className="icon-image right">
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    </div>}
                                </li>
                        )})}
                            <li>
                                <div className="section-header defaultcursor">
                                    { !this.state.isLoadingGrunndata &&
                                        <div className="icon-image"><div className="img"></div></div>
                                    }
                                    { this.state.isLoadingGrunndata &&
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    }
                                    <span className="title">{t('grunndata')}</span>
                                </div>
                            </li>
                            { this.state.grunndata.map((d, index) => { return (
                                <li key={d.dokumentnummer+d.dokumentnavn} className="section-header subsection defaultcursor">
                                    <span className={`icon sublevel ${index == this.state.grunndata.length-1 ? 'sublevel-end' : ''}`}></span>
                                    <span className="title">{d.dokumentaar} {d.dokumentnavn}</span>
                                    { d.kanPantebokbestilles == false && <div className="icon-image tooltip warning">
                                        <img className="tool" src={WarningIcon} />
                                        <div className="tooltip-content">{t('kanikkebestilletinglystdokument')}</div>
                                    </div> }
                                    <div className="icon-image right"><div className="collapse"></div></div>
                                    { !d.isValidating && d.kanPantebokbestilles == undefined && <div className="icon-image right tooltip" onClick={e => this.onSelectDocument(d)}>
                                        <img className="tool" src={BestillTinglystDokumentIcon} />
                                        <div className="tooltip-content">{t('bestilltinglystdokument')}</div>
                                    </div>}
                                    { d.isValidating && <div className="icon-image right">
                                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                                    </div>}
                                </li>
                        )})}
                        </ul>
                    </React.Fragment>
                }

                { this.state.orderReference == null && this.state.selectedDocument &&
                    <React.Fragment>
                    <div className="section-header defaultcursor description multiline">
                        {t('registreradresse')}
                    </div>

                    <div className="section-header defaultcursor order-label topborder">
                        <span className="title">{t('fulltnavn')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input">
                        <input type="text" ref={input => this.fulltnavn = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('gatenavnognummer')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input">
                        <input type="text" ref={input => this.gatenavnognummer = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('postnummer')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input postnummer">
                        <input type="text" ref={input => this.postnummer = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('fakturareferanse')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input postnummer">
                        <input type="text" maxLength="15" ref={input => this.fakturareferanse = input} />
                    </div>

                    { this.state.selectedDocument.erBestilt &&
                            <div className="section-header defaultcursor description">
                                <span className="title">{t('dokumentalleredebestilt')}</span>
                            </div>
                    }

                    { this.state.orderError != null &&
                        <div className="section-header defaultcursor description multiline">
                            <span className="title">{this.state.orderError}</span>
                        </div>
                    }

                    <div className="section-header defaultcursor buttons">
                        <div className="button buttonspinner" onClick={this.sendOrder}>
                            <span className="icon"><i className={`${this.state.isLoading ? 'fa fa-fw fa-spinner fa-spin' : 'fa fa-fw'}`}></i></span>
                            <span>{t('sendbestilling')}</span>
                        </div>
                    </div>
                </React.Fragment>                
                }

                { this.state.orderReference != null &&
                    <div className="section-header defaultcursor multiline topborder">
                        {t('tinglystdokumentbestilt', { dokumentaar: this.state.selectedDocument.dokumentaar, dokumentnummer: this.state.selectedDocument.dokumentnummer, referanse: this.state.orderReference })}
                    </div>
                }                
            </li>
        )
    }
}

export default withTranslation('common')(OrderTinglysteDokumenter)